// vendors
import { CdkConnectedOverlay } from '@angular/cdk/overlay';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
// feature
import { BaseNotebookCellButtonComponent } from '../base-button.component';

@Component({
  selector: 'mode-notebook-add-cell-button',
  templateUrl: './notebook-add-cell-button.component.html',
  styleUrls: ['./notebook-add-cell-button.component.scss'],
})
export class NotebookAddCellButtonComponent extends BaseNotebookCellButtonComponent {
  @ViewChild(CdkConnectedOverlay) connectedOverlayDirective!: CdkConnectedOverlay;

  @Input()
  nextCellToken?: string;

  @Output()
  insertCellAbove: EventEmitter<string> = new EventEmitter();

  @Output()
  insertCellBelow: EventEmitter<string> = new EventEmitter();

  isNewCellDialogOpen = false;

  constructor() {
    super();
  }

  insertAbove() {
    if (!this.cellToken) {
      return;
    }

    this.insertCellAbove.emit(this.cellToken);
  }

  insertBelow() {
    this.insertCellBelow.emit(this.nextCellToken);
  }
}
